import React, { useState, useEffect } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import axios from 'axios'; // Import axios for API calls
import { backendlink } from '../../config';
import "./doctor-patient-ecg-datagrid.scss"
import { LoadIndicator } from 'devextreme-react';

const FiveMinIntervalChart = ({ setECGDataID, FiveMinIntervalID, user, patientToken }) => {
  const [data, setData] = useState([]);
  const [selectedBoxId, setSelectedBoxId] = useState(null); // State to track the selected box
  const [loading, setLoading] = useState(false); // State to track loading status

  // Fetch data from the API
  useEffect(() => {

    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching data

      try {
        const response = await axios.get(backendlink + 'doctor/getpatient30sec',
          {
            params: {
              patienttoken: patientToken,
              ecgdataid: FiveMinIntervalID,
            },
            headers: {
              token: user.token,
            },
          });
        console.log('Transformed Data1:', response.data.result);
        const transformedData = transformApiResponse(response.data.result);
        console.log('Transformed Data:2', transformedData);
        setData(transformedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    if (FiveMinIntervalID) {
      fetchData();
      setSelectedBoxId(null); // Reset selected box ID when fetching new data
    }
  }, [FiveMinIntervalID]);


  // Transform API response to match the grid's data structure in column-major order
  const transformApiResponse = (apiData) => {
    const ecgIntervalData = apiData; // Assuming the data is directly usable
    const rows = 10; // Fixed number of rows
    const cols = 2; // Fixed number of columns

    return Array.from({ length: rows }, (_, rowIndex) => {
      const row = {
        rowTitle: (rowIndex % 2 === 0) // Show only for rows 1, 3, 5, 7, 9 (odd indices)
          ? ecgIntervalData[rowIndex]?.startAt
            ? new Date(ecgIntervalData[rowIndex].startAt * 1000).toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false, // Use 24-hour format
            }) // Display as HH:mm:ss in local time
            : '' // Leave empty if no startAt value
          : '', // Leave empty for other rows
      };

      const currentData = ecgIntervalData[rowIndex];
      if (currentData.id !== '') {
        if (currentData.risk === false) {
          row[`h0`] = {
            id: currentData.id,
            risk: currentData.risk,
          };
          row[`h1`] = {
            id: null,
            risk: null,
          };
        }
        if (currentData.risk === true) {
          row[`h0`] = {
            id: null,
            risk: null,
          };
          row[`h1`] = {
            id: currentData.id,
            risk: currentData.risk,
          };
        }
      }
      else {
        row[`h0`] = {
          id: null,
          risk: null,
        };
        row[`h1`] = {
          id: null,
          risk: null,
        };
      }

      return row;
    });
  };

  const cellRender = (cellData) => {
    const { id, risk } = cellData.value || {};
    const isSelected = selectedBoxId === id; // Check if this box is selected
    const isNonClickable = (id === null || id === '');

    return (
      <div
        onClick={() => {
          if (id) {
            setSelectedBoxId(id); // Set the selected box ID
            setECGDataID(id); // Pass the ID to the parent
          }
        }}
        style={{
          width: '160px',
          height: '24px',
          backgroundColor: isNonClickable ? '#FFFFFF' : risk === true ? '#FFDAD6' : '#D7E3FF', // Red for risk=true, green for risk=false
          opacity: selectedBoxId === null || isSelected ? 1 : 0.25, // Opacity logic
          border: isNonClickable
            ? 'none' // No border for non-clickable boxes
            : isSelected
              ? '1px solid var(--Schemes-Surface-On-Surface, #181C23)' // Border for selected boxes
              : 'none', // No border for non-selected boxes
          borderRight: isNonClickable
            ? 'none' // No border for non-clickable boxes
            : !isSelected
              ? 'none'
              : risk === true
                ? '2px solid var(--Schemes-Surface-On-Surface, #181C23)' // Border for selected boxes
                : '2px solid var(--Schemes-Surface-On-Surface, #181C23)', // Border for selected boxes
          alignItems: 'center',
          justifyContent: 'center',
          cursor: id ? 'pointer' : 'default',
          userSelect: 'none',
          fontSize: 12,
          whiteSpace: 'nowrap',
          padding: 0,
          margin: 0,
          boxSizing: 'border-box',
        }}
      >
      </div>
    );
  };

  const rowTitleColumn = (
    <Column
      key="rowTitle"
      dataField="rowTitle"
      caption=""
      width={31}
      allowSorting={false}
      allowFiltering={false}
      allowEditing={false}
      cellRender={(cellData) => (
        <div
          style={{
            fontWeight: '400',
            fontSize: 12,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            height: '100%',
            backgroundColor: '#FFFFFF',
            userSelect: 'none',
            color: '#717786'
          }}
        >
          {cellData.value}
        </div>
      )}
    />
  );

  // Dynamically create columns for h0 to h1
  const dataColumns = Array.from({ length: 2 }, (_, colIndex) => (
    <Column
      key={`h${colIndex}`}
      dataField={`h${colIndex}`}
      cellRender={cellRender}
      width={160}
      allowSorting={false}
      allowFiltering={false}
      allowEditing={false}
      alignment="center"
      headerCellRender={() => (
        <div >
          {colIndex === 0 ? 'No Risk Detected' : 'Risk Detected'} {/* Set titles dynamically */}
        </div>
      )}
    />
  ));

  return (
    <div class="interval-chart" style={{
     marginTop: 20
    }}>
      <div
        className='titles'
        style={{
          textAlign: 'center',
          paddingBottom: '10px',
        }}
      >
        AI Result of Selected Interval
      </div>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '300px', // Adjust height to center vertically
            width: '100%', // Full width
          }}
        >
          <LoadIndicator
            width={50}
            height={50}
          />
        </div>) : (
      <div>
      {/* Center the DataGrid */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '20px', // Add spacing between DataGrid and legend
        }}
      >
          <DataGrid
            dataSource={data}
            showBorders={true}
            columnAutoWidth={false}
            allowColumnReordering={false}
            allowColumnResizing={false}
            rowAlternationEnabled={false}
            showColumnLines={true}
            showRowLines={true}
            sorting={{ mode: 'none' }}
            filterRow={{ visible: false }}
            paging={{ enabled: false }}
            editing={{ mode: 'none' }}
            width={354}
          >
            {rowTitleColumn}
            {dataColumns}
          </DataGrid>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '10px',
              gap: '20px',
              fontFamily: 'Open Sans',
              fontSize: '12px',
              lineHeight: '16px',
              paddingTop: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: '#D7E3FF', // Blue for no risk
                  border: '1px solid #000',
                }}
              ></div>
              <span className="text-center-small">No Risk Detected</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  backgroundColor: '#FFDAD6', // Red for risk
                  border: '1px solid #000',
                }}
              ></div>
              <span className="text-center-small">Risk Detected</span>
            </div>
          </div>
        </div>
      )}

    </div >
  );
};

export default FiveMinIntervalChart;